import { InjectionToken } from '@angular/core';

export const WINDOW_TOKEN = new InjectionToken('window', { providedIn: 'root', factory: () => window });
